// extracted by mini-css-extract-plugin
export default {"GoogleButtonBlock":"GoogleButtonBlock_GoogleButtonBlock__UTWw+","GoogleButtonBlockLabel":"GoogleButtonBlock_GoogleButtonBlockLabel__X0UfU"};